module.exports = __webpack_public_path__ + "img/THEORIC_TRAINING.69b98965.webp";